var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 8A6.4 6.4 0 111.6 8a6.4 6.4 0 0112.8 0zM5.372 6.202a.587.587 0 11.83-.83L8 7.17l1.798-1.798a.587.587 0 11.83.83L8.83 8l1.798 1.798a.587.587 0 11-.83.83L8 8.83l-1.798 1.798a.587.587 0 11-.83-.83L7.17 8 5.372 6.202z",
    fill: "#5F787E"
  })));
}
export default SvgIconSmallClose;